import { FC, useCallback } from "react";
import { PlayIcon } from "@icons";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import { useViewOnlyRefusal } from "@hooks/permissions/useViewOnlyRefusal";
import { useCommands } from "./useCommands";
import { useStartCloseAgent } from "./useStartCloseAgent";

export const StartCloseAgentCommandItem: FC = () => {
    const { close: closeCommands } = useCommands();
    const { refuseIfViewOnly } = useViewOnlyRefusal();
    const { isReady, openCloses, startFromPicker } = useStartCloseAgent();

    const onSelect = useCallback(() => {
        if (refuseIfViewOnly()) {
            return;
        }
        // With several closes the picker directory replaces this list, so
        // the palette stays open; otherwise it closes before the start.
        if (openCloses.length !== 1 && openCloses.length !== 0) {
            startFromPicker();
            return;
        }
        closeCommands();
        startFromPicker();
    }, [refuseIfViewOnly, openCloses, closeCommands, startFromPicker]);

    return (
        <CommandItem
            onSelect={onSelect}
            disabled={!isReady}
            disabledTooltip="Loading closes…"
            keywords={["agent", "close", "monthly", "books", "run"]}
        >
            <PlayIcon /> Run monthly close with Kick agent
        </CommandItem>
    );
};
